import { Country } from './../../shared';

export class TripInfo {
    public departureDate: string;
    public returnDate: string;
    public depositDate: string;
    public destinationCountry: Country = new Country();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/models/trip-info.model.ts